module.exports = __webpack_public_path__ + "img/sequence-miyashita-park-sp.f7c158b8.jpg";